import React from "react";
import PartnerFormPage from "../components/partners/PartnerFormPage";

const PartnerEdit = () => <PartnerFormPage mode="edit" />;

export default PartnerEdit;
